export const HotelDiscountCalculator = (bookingData, serviceDetails) => {
  const basePriceFirstDog = serviceDetails && serviceDetails.hotel ? serviceDetails.hotel[0].price : 80;
  const basePriceForWalk = serviceDetails && serviceDetails.walk ? serviceDetails.walk[0].price : 20;
  const petDiscount = 0.10; // 10% discount for each additional pet

  var total = 0;
  var originalTotal = 0;
  var selectedPets = bookingData && bookingData.selectedPets ? bookingData.selectedPets : [];
  var numberOfPets = selectedPets.length;
  var numberOfNights = calculateNumberOfNights(bookingData.dateRange);

  for (var i = 0; i < numberOfPets; i++) {
    var pet = selectedPets[i];
    var type = pet && pet.petType ? pet.petType : "Dog";

    // figure out base price for this pet
    var petBasePrice = basePriceFirstDog;
    if (type === "Cat") {
      petBasePrice = basePriceFirstDog - 20;
    }

    if (i === 0) {
      // first pet full price
      total += petBasePrice * numberOfNights;
      originalTotal += petBasePrice * numberOfNights;
    } else {
      // additional pets discounted
      var discountRate = petDiscount * i;
      var discountedPricePerNight = petBasePrice * (1 - discountRate);
      total += discountedPricePerNight * numberOfNights;
      originalTotal += petBasePrice * numberOfNights;
    }
  }

  // Food pricing
  if (bookingData && bookingData.foodPreference === 'premium') {
    total += 10 * numberOfNights * numberOfPets;
    originalTotal += 10 * numberOfNights * numberOfPets;
  } else if (bookingData && bookingData.foodPreference === 'basic') {
    total += 0 * numberOfNights * numberOfPets;
    originalTotal += 0 * numberOfNights * numberOfPets;
  }

  // Walk add-on
  var add = bookingData && bookingData.additionalServices ? bookingData.additionalServices : null;
  if (add && add.walk) {
    total += basePriceForWalk * numberOfPets;
    originalTotal += basePriceForWalk * numberOfPets;
  }

  return { originalPrice: originalTotal, discountedPrice: total };
};

// unchanged
function calculateNumberOfNights(dateRange) {
  if (dateRange && dateRange.length === 2) {
    var startDate = new Date(dateRange[0]);
    var endDate = new Date(dateRange[1]);
    var numberOfNights = Math.ceil((endDate - startDate) / (24 * 60 * 60 * 1000)) - 1;
    return Math.max(numberOfNights, 1);
  }
  return 0;
}

export default HotelDiscountCalculator;
